import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Text} from '@/components/ui/text/Text'
import {StyledHomeCard} from './style'
import {ButtonLink} from '@/components/ui/button-link/ButtonLink'
import {routes} from '@/utilities/constants/routes'
import {LinkExternal01Icon} from '@/components/ui/icon/Icon'
import {useTranslation} from 'react-i18next'
import {useAuthStore, usePermissions} from '@/features/auth/store/store'
import {HomeProjectsSkeleton} from './HomeProjectsSkeleton'
import {useGetHomePageData} from '../../query/useGetHomePageData'
import {useMemo} from 'react'

export const HomeProjectsCard = () => {
    const {t} = useTranslation()
    const permissions = usePermissions()
    const {data, isLoading} = useGetHomePageData({fields: ['projects']})
    const {user} = useAuthStore()

    const projectSearchParams = useMemo(() => {
        return new URLSearchParams({
            filters: JSON.stringify({
                operator: 'and',
                fields: [{key: 'consultant', operator: 'in', value: [user?.id]}]
            })
        }).toString()
    }, [user?.id])

    return (
        <StyledHomeCard>
            <Flexbox gap={2} align="center">
                <Text size="textMd" weight={500} palette="neutral" shade="600">
                    {t('homepage:projects_in_management')}
                </Text>
                {permissions?.projects?.read && (
                    <ButtonLink
                        shape="text"
                        variant="ghost"
                        size="sm"
                        to={{pathname: routes.PROJECTS_ROUTE.handle.path, search: projectSearchParams}}
                    >
                        <LinkExternal01Icon />
                    </ButtonLink>
                )}
            </Flexbox>

            {isLoading ? (
                <HomeProjectsSkeleton />
            ) : (
                <>
                    <Text size="displayMd" palette="neutral" shade="900" weight={700}>
                        {data?.projects?.total}
                    </Text>
                    <Flexbox direction="column" gap={2}>
                        <Flexbox gap={2}>
                            <Text weight={500} size="textSm" palette="neutral" shade="950">
                                {data?.projects?.expiring}
                            </Text>
                            <Text size="textSm" palette="neutral" shade="600">
                                {t('homepage:in_expiration')}
                            </Text>
                        </Flexbox>
                        <Flexbox gap={2}>
                            <Text weight={500} size="textSm" palette="neutral" shade="950">
                                {data?.projects?.suspended}
                            </Text>
                            <Text size="textSm" palette="neutral" shade="600">
                                {t('homepage:suspended')}
                            </Text>
                        </Flexbox>
                    </Flexbox>
                </>
            )}
        </StyledHomeCard>
    )
}
